import React, { useEffect, useState } from "react";

import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";

import { CloseButton } from "components/CloseButton";
import { getRouteSheetList, getRouteSheetStatuses, updateDelivery } from "services/api";
import { MySpinner } from "components/MySpinner";
import { StatusOrderToProvider } from "components/StatusOrderToProvider";

import { RouteSheetAddModal } from "../RouteSheetAddModal";
import { dateFormatU } from "utils/format";

export const RouteSheetModal = ({
  openModal,
  setOpenModal,
  deliveryId,
  getAndSetDeliveryList
}) => {

  const [openAddModal, setOpendAddModal] = useState(false);
  const [routeSheets, setRouteSheets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statuses, setStatuses] = useState([]);

  const onClose = () => {
    setOpenModal(false);
  }

  const getAndSetRouteSheetStatuses = () => {
    getRouteSheetStatuses()
      .then(setStatuses)
      .catch((e) => {
        toast.error(e.response?.data?.message);
      });
  }

  const getAndSetRouteSheets = () => {
    setLoading(true);
    getRouteSheetList({
      dateStart: dateFormatU(new Date()),
    })
      .then((res) => {
        setRouteSheets(res.items);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (openModal) {
      getAndSetRouteSheetStatuses();
      getAndSetRouteSheets();
    }
  }, [openModal]);

  const statusHandler = () => {

  }

  const setRouteSheet = (routeSheetId) => {
    setLoading(true);
    updateDelivery({
      id: deliveryId,
      routeSheet: routeSheetId
    })
      .then((res) => {
        getAndSetDeliveryList();
        setOpenModal(false);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Modal isOpen={openModal} toggle={onClose}>
        <ModalHeader>
          <div className="modal-title-text">Маршрутные листы</div>
          <CloseButton onClick={onClose} />
        </ModalHeader>
        <ModalBody className="m-3">

          {loading && <MySpinner overlay />}

          <div className="mb-2">
            <Button onClick={() => setOpendAddModal(true)}>Добавить маршрутный лист</Button>
          </div>

          <div className="react-bootstrap-table p-0 articles">
            <Table className="table table-hover pointer">
              <tbody>
                {routeSheets && routeSheets.map((route) =>
                  <tr key={route.id} onClick={() => setRouteSheet(route.id)}>
                    <td>
                      {route.number}
                    </td>
                    <td>
                      {route.driver?.name}
                    </td>
                    <td>
                      {moment(route.date).format("DD.MM.Y")}
                    </td>
                    <td>
                      <StatusOrderToProvider
                        status={{
                          color: route.status.color,
                        }}
                        statuses={statuses}
                        statusHandler={(status) => statusHandler(route.id, status)}
                      >
                        {route.status.name}
                      </StatusOrderToProvider>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-end">
            <Button type="button" onClick={onClose} color="secondary">
              Закрыть
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <RouteSheetAddModal
        openModal={openAddModal}
        setOpenModal={setOpendAddModal}
        loading={loading}
        getAndSetRouteSheets={getAndSetRouteSheets}
      />
    </>
  );
};
